import React, { useState, useEffect } from 'react';
import './AddScenarioColumnModal.css';

const AddScenarioColumnModal = ({ isOpen, onClose, properties, savedScenarios, onAdd }) => {
    const [selectedPropertyId, setSelectedPropertyId] = useState('');
    const [selectedScenarioId, setSelectedScenarioId] = useState('default');

    // Reset selections when modal opens
    useEffect(() => {
        if (isOpen && properties.length > 0) {
            setSelectedPropertyId(String(properties[0].property_id));
            setSelectedScenarioId('default');
        }
    }, [isOpen, properties]);

    if (!isOpen) return null;

    const scenarios = savedScenarios[selectedPropertyId] || [];

    const handleAdd = () => {
        if (!selectedPropertyId) return;
        if (selectedScenarioId === 'default') {
            onAdd(selectedPropertyId, null);
        } else {
            const scenario = scenarios.find(s => s.id === selectedScenarioId);
            if (scenario) onAdd(selectedPropertyId, scenario);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="asm-modal" onClick={e => e.stopPropagation()}>
                <h3 className="asm-title">Add Comparison Column</h3>
                <p className="asm-subtitle">Choose a property and scenario to add as a new column.</p>

                <div className="asm-field">
                    <label>Property</label>
                    <select
                        className="asm-select"
                        value={selectedPropertyId}
                        onChange={e => {
                            setSelectedPropertyId(e.target.value);
                            setSelectedScenarioId('default');
                        }}
                    >
                        {properties.map(p => (
                            <option key={p.property_id} value={String(p.property_id)}>
                                {p.address} — {p.city}, {p.state}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="asm-field">
                    <label>Scenario</label>
                    <select
                        className="asm-select"
                        value={selectedScenarioId}
                        onChange={e => setSelectedScenarioId(e.target.value)}
                    >
                        <option value="default">Default</option>
                        {scenarios.map(s => (
                            <option key={s.id} value={s.id}>
                                {s.name} ({(s.results?.cashOnCashROI || 0).toFixed(1)}%)
                            </option>
                        ))}
                    </select>
                </div>

                <div className="asm-actions">
                    <button className="asm-btn-cancel" onClick={onClose}>Cancel</button>
                    <button className="asm-btn-add" onClick={handleAdd}>Add Column</button>
                </div>
            </div>
        </div>
    );
};

export default AddScenarioColumnModal;
